import { Component, OnInit, ViewChild } from '@angular/core';
import { Article } from "../article/article";
import { categories } from "../../assets/categories";
import { Router } from '@angular/router';
import { ArticleService } from "../article/article.service";
import { trigger, state, style, animate, transition } from '@angular/animations';
import {Alert} from "../alert/alert";

@Component({
  selector: 'app-add-article',
  templateUrl: './add-article.component.html',
  styleUrls: ['./add-article.component.css']
})
export class AddArticleComponent implements OnInit {

  public article:Article;
  public mainCategories:String[] = categories.main;
  public subCategories:String[];
  public selectedCat:String;
  public soldOut:boolean = false;
  public formData:FormData = new FormData();

  public alert:Alert;

  constructor(public router:Router,
              private articleService:ArticleService) {
  }

  ngOnInit() {
    this.alert = new Alert('hide', '', '');
    this.article = new Article("", "", "", "", "", false, "", "", "", false);
  }

  onSubmit() {
    // add all article attr to formData obj
    Object.keys(this.article).forEach(key => {
      this.formData.append(key, this.article[key]);
    });

    // initiate bookshelf request
    this.articleService.createArticle(this.formData).subscribe(
      suc => {
        this.alert.update('show', 'alert-success', "Artikel wurder erfolgreich erstellt");
        this.router.navigate(['overview', this.alert]);
      },
      err => {
        if (err.status == 403) {
          this.router.navigate(['login']);
        }

        else {
          this.alert.update('show', 'alert-danger', err._body);
          setTimeout(() => this.alert.state = 'hide', 4000);
        }
      }
    )
  }

  public fileUploaded(event, fieldname):void {
    // parse file from event obj
    let file = event.target.files[0];

    // attach file to formData obj
    this.formData.append(fieldname, file);
  }

  public showSubCats(mainCategory) {
    switch (mainCategory) {
      case 'Postkarten':
        this.article.category = mainCategory;
        break;
      case 'Bücher':
        this.subCategories = categories.subcategories.books;
        this.article.category = '';
        break;
      case 'Kartografie':
        this.subCategories = categories.subcategories.maps;
        this.article.category = '';
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/add-article/add-article.component.ts